import { render, staticRenderFns } from "./BilanzTable.vue?vue&type=template&id=26523bd2&"
import script from "./BilanzTable.vue?vue&type=script&lang=ts&"
export * from "./BilanzTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports